import { usePage } from "@inertiajs/react";
import { DefaultLayoutWrapper } from "layouts/DefaultLayout";
import Container from "hardcover-ui/components/Container";
import ProfileWrapper from "components/profile/ProfileWrapper";
import Pagination from "components/shared/Pagination";
import { UserGoalsPageProps } from "./index.props";
import GoalNav from "components/profile/GoalNav";
import PageHeader from "components/shared/PageHeader";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import NewGoalLink from "components/profile/NewGoalLink";
import flagIcon from "icons/solid/flag-checkered.svg";
import Goals from "components/profile/Goals";

function UserGoalsPage() {
  const { user, goals } = usePage<UserGoalsPageProps>().props;
  const currentUserId = useCurrentUserId();

  return (
    <ProfileWrapper user={user}>
      <Container size="lg" className="pt-4 md:px-2">
        <GoalNav user={user} />

        <PageHeader
          title="Reading Goals"
          description="Sorted by closest deadlines first."
          icon={flagIcon}
          className="mt-4 mb-8"
        >
          <>{currentUserId === user.id ? <NewGoalLink /> : false}</>
        </PageHeader>
        
        <Goals user={user} goals={goals} />
        <Pagination />
      </Container>
    </ProfileWrapper>
  );
}

UserGoalsPage.layout = DefaultLayoutWrapper;
export default UserGoalsPage;